var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 12C3.37501 11.9006 3.41452 11.8052 3.48484 11.7349C3.55517 11.6646 3.65055 11.625 3.75 11.625L19.3447 11.625L13.2349 5.51518C13.2 5.48036 13.1724 5.43902 13.1536 5.39353C13.1347 5.34804 13.125 5.29928 13.125 5.25004C13.125 5.2008 13.1347 5.15204 13.1536 5.10655C13.1724 5.06106 13.2 5.01972 13.2349 4.9849C13.2697 4.95008 13.311 4.92247 13.3565 4.90362C13.402 4.88478 13.4508 4.87508 13.5 4.87508C13.5492 4.87508 13.598 4.88478 13.6435 4.90362C13.689 4.92247 13.7303 4.95008 13.7651 4.9849L20.5151 11.7349C20.55 11.7697 20.5776 11.811 20.5964 11.8565C20.6153 11.902 20.625 11.9508 20.625 12C20.625 12.0493 20.6153 12.098 20.5964 12.1435C20.5776 12.189 20.55 12.2304 20.5151 12.2652L13.7651 19.0152C13.6948 19.0855 13.5994 19.125 13.5 19.125C13.4006 19.125 13.3052 19.0855 13.2349 19.0152C13.1645 18.9449 13.125 18.8495 13.125 18.75C13.125 18.6506 13.1645 18.5552 13.2349 18.4849L19.3447 12.375L3.75 12.375C3.65055 12.375 3.55517 12.3355 3.48484 12.2652C3.41452 12.1949 3.37501 12.0995 3.375 12Z",
    fill: "#222228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.a7ddbd28e60d251e817e20880e205f42.svg";
export { ForwardRef as ReactComponent };